import { render, staticRenderFns } from "./Login2FaScreen.vue?vue&type=template&id=1f46aa94&"
import script from "./Login2FaScreen.vue?vue&type=script&lang=ts&"
export * from "./Login2FaScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports